/**
 * @author John Lukose <john.lukose@quikr.com>
 *
 * Utility functions for remaining post ad features
 */

import localStorageWrapper from '../../LocalStorageWrapper';
import root from 'window-or-global';
import { LOCALITY_SEARCH_API } from '../../../constants/apiEndpoints';
import FetchHelper from "../../FetchHelper";
import { LOCALSTORAGE_KEYS } from '../../../constants';

export class RoleSubRole {
  static options = [];

  static localStorageKey = 'roleSubRoleOptions';

  static getOptions = () => (RoleSubRole.options);

  static getIndexedOptions = () => {
    let options = {};
    RoleSubRole.options.forEach(item => {
      options[item.id] = item;
    });

    return options;
  };

  static setOptions = optionsList => {
    RoleSubRole.options = optionsList;
  };

  static isOptionsStored = () => {
    return localStorageWrapper.hasKey(RoleSubRole.localStorageKey);
  };

  static getOptionsFromStorage = () => {
    let options = [];
    if (RoleSubRole.isOptionsStored()) {
      options = JSON.parse(root.localStorage.getItem(RoleSubRole.localStorageKey));
    }
    return options;
  };

  static setOptionsInStorage = options => {
    root.localStorage.setItem(RoleSubRole.localStorageKey, JSON.stringify(options));
  };

  static updateOptionsFromContext = response => {
    let roleSubRoleOptions = [];
    if (RoleSubRole.isOptionsStored()) {
      roleSubRoleOptions = RoleSubRole.getOptionsFromStorage();
    } else {
      if (response && response.json && response.json.hasOwnProperty('roleSubRoleOptions')) {
        let newOptions = response.json.roleSubRoleOptions;
        RoleSubRole.setOptionsInStorage(newOptions);
        roleSubRoleOptions = newOptions;
      }
    }
    RoleSubRole.setOptions(roleSubRoleOptions);
  }
}

export class CityOptions {
  static options = [];

  static localStorageKey = 'getAllCities';

  static getOptions = () => (CityOptions.options);

  static getIndexedOptions = () => {
    let options = {};
    CityOptions.options.forEach(item => {
      options[item.id] = item;
    });

    return options;
  };

  static setOptions = optionsList => {
    CityOptions.options = optionsList;
  };

  static isOptionsStored = () => {
    return localStorageWrapper.hasKey(CityOptions.localStorageKey);
  };

  static getOptionsFromStorage = () => {
    let options = [];
    if (CityOptions.isOptionsStored()) {
      options = JSON.parse(root.localStorage.getItem(CityOptions.localStorageKey));
    }
    return options;
  };

  static setOptionsInStorage = options => {
    root.localStorage.setItem(CityOptions.localStorageKey, JSON.stringify(options));
  };

  static updateOptionsFromContext = response => {
    let cityOptions = [];
    if (CityOptions.isOptionsStored()) {
      cityOptions = CityOptions.getOptionsFromStorage();
    } else {
      if (response && response.json && response.json.cityOptions) {
        let newOptions = response.json.cityOptions;
        CityOptions.setOptionsInStorage(newOptions);
        cityOptions = newOptions;
      }
    }
    CityOptions.setOptions(cityOptions);
  }

  static getLocalities = (city) => {
    let url = LOCALITY_SEARCH_API + city;
    let searchListFromCache = CityOptions.getSearchListFromLocalStorage(url);
    if(searchListFromCache && searchListFromCache.length > 0){
      return searchListFromCache;
    }else{
      let fetchHelper = new FetchHelper();
      let params = {
        url : url
      };
      let localityResponse = fetchHelper.request('GET', params);
      localityResponse.then((response) => {
        response = (response.data) ? response.data : {};
        if (response.json && response.success) {
          CityOptions.setSearchListToLocalStorage(response.json,url);
          return JSON.parse(response.json);
        }
      });
    }
  }

  static getSearchListFromLocalStorage = (url) => {
    let key = CityOptions.getSearchCacheKey(url);
    let listString = root.localStorage.getItem(key);
    return JSON.parse(listString);
  }

  static getSearchCacheKey = (url) => {
    if (url) {
      let parts = url.split('/');
      return parts[parts.length - 1];
    }
  }
  static setSearchListToLocalStorage = (list,url) => {
    if (!list || list.length === 0){
      return;
    }
    let key = CityOptions.getSearchCacheKey(url);
    root.localStorage.setItem(key, JSON.stringify(list));
  }

  static getCityId(city){
    let cityList = JSON.parse(root.localStorage.getItem(LOCALSTORAGE_KEYS.ALL_CITIES));
    cityList.forEach(cityObj => {
      if(city === cityObj.value){
        return cityObj.id;
      }
    });
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/others/otherFeatures.js